import React from 'react'
import { component_tool } from '@/tool'
const { WizComponent, WizInput, WizRow, WizCol } = component_tool;
const { TextArea } = WizInput;

export default class QsTextarea extends WizComponent {
    render() {
        const { preview, answer } = this.props
        let textAreaProps = {
            rows: 4,
            placeholder: "请输入"
        }
        return (
            <WizRow>
                <WizCol>
                    { !preview ? answer : <TextArea {...textAreaProps} /> }
                </WizCol>
            </WizRow>
        )
    }
}